/**
 * Whether this browser is being driven by an automated test.
 *
 * `navigator.webdriver` is the standard signal for an automated browser and is set by
 * Playwright. It is read defensively because this also runs where `navigator` is not a
 * browser's.
 *
 * Two things hide behind this: the development-only devtools panels (see `devChrome.ts`)
 * and Shake (see `shake.ts`), whose feedback button only shows once Shake has started. Both
 * are fixed to an edge of the viewport and both would intercept the clicks a test aims at the
 * app underneath.
 */
export function isAutomatedBrowser(): boolean {
    return typeof navigator !== 'undefined' && navigator.webdriver;
}
